module.exports = __webpack_public_path__ + "img/744.0c1cd8ec.jpg";